import React, { useEffect, useRef } from 'react'
import '../styles/PricingPlans.css'
import { T } from './Translation'

function PricingPlans() {
  const pricingRef = useRef(null)

  useEffect(() => {
    // This effect handles direct navigation to #pricing from URL
    if (window.location.hash === '#pricing' && pricingRef.current) {
      pricingRef.current.scrollIntoView({ behavior: 'smooth' })
    }
  }, [])

  const handleChoosePlan = (planName) => {
    const phoneNumber = '972552642897' // WhatsApp format: country code + number without dashes
    const message = `היי, אני מעוניין להצטרף לתוכנית של Invitly. אפשר לקבל מידע נוסף ?`
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`
    window.open(whatsappUrl, '_blank')
  }

  const handleSpecialSaleClick = () => {
    const phoneNumber = '972552642897' 
    const message = `היי, אני מעוניין לקבל מידע על המבצע המיוחד והמחירים המוזלים!`
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`
    window.open(whatsappUrl, '_blank')
  }

  return (
    <section id="pricing" ref={pricingRef} className="pricing-section">
      
      <h2>
        <T k="ourPricingPlans" />
      </h2>
      <div className="pricing-cards">
        {/* Basic plan */}
        <div className="pricing-card">
          <h3>
            <T k="basicPlan" />
          </h3>
          <p className="price">
            <T k="basicPrice" />
          </p>
          <ul>
            <li>
              <T k="basicFeature1" />
            </li>
            <li>
              <T k="basicFeature2" />
            </li>
            <li>
              <T k="basicFeature3" />
            </li>
            <li>
              <T k="basicFeature4" />
            </li>
          </ul>
          <button onClick={() => handleChoosePlan('Basic')}>
            <T k="choosePlan" />
          </button>
        </div>

        {/* Premium plan */}
        <div className="pricing-card featured">
          <h3>
            <T k="premiumPlan" />
          </h3>
          <p className="price">
            <T k="premiumPrice" />
          </p>
          <ul>
            <li>
              <T k="premiumFeature1" />
            </li>
            <li>
              <T k="premiumFeature2" />
            </li>
            <li>
              <T k="premiumFeature3" />
            </li>
            {/* <li>
              <T k="premiumFeature4" />
            </li> */}
          </ul>
          <button onClick={() => handleChoosePlan('Premium')}>
            <T k="choosePlan" />
          </button>
        </div>

        {/* Premium Plus plan
        <div className="pricing-card">
          <h3>
            <T k="premiumPlusPlan" />
          </h3>
          <p className="price">
            <T k="premiumPlusPrice" />
          </p>
          <ul>
            <li>
              <T k="premiumPlusFeature1" />
            </li>
            <li>
              <T k="premiumPlusFeature2" />
            </li>
            <li>
              <T k="premiumPlusFeature3" />
            </li>
            <li>
              <T k="premiumPlusFeature4" />
            </li>
            <li>
              <T k="premiumPlusFeature5" />
            </li>
          </ul>
          <button>
            <T k="choosePlan" />
          </button>
        </div> */}
      </div>
    </section>
  )
}

export default PricingPlans
